import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import App from './App';
import { ChessboardTouchDnDProvider } from './features/common/ChessboardTouchDnDProvider';
import { AuthProvider } from './features/auth/AuthContext';
import { UserSettingsProvider } from './features/settings/useUserSettings';
import { ReviewCountsProvider } from './features/review/useReviewCounts';
import { AppRecoveryFallback } from './features/common/appRecoveryFallback';
import { initSentry, Sentry } from './features/common/sentry';
import { darkTheme, isAltDev } from './theme';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

initSentry();

const SentryFallback = () => (
  <ThemeProvider theme={darkTheme}>
    <CssBaseline />
    <AppRecoveryFallback />
  </ThemeProvider>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ChessboardTouchDnDProvider>
    <React.StrictMode>
      <Sentry.ErrorBoundary fallback={<SentryFallback />}>
        <AuthProvider>
          <UserSettingsProvider>
            <ReviewCountsProvider>
              <App />
            </ReviewCountsProvider>
          </UserSettingsProvider>
        </AuthProvider>
      </Sentry.ErrorBoundary>
    </React.StrictMode>
  </ChessboardTouchDnDProvider>,
);

if (isAltDev) {
  serviceWorkerRegistration.unregister();
} else {
  serviceWorkerRegistration.register({
    onUpdate() {
      // DeployFreshness listens via subscribeToServiceWorkerUpdate.
    },
  });
}
